/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Stack,
  Link,
  Typography,
  Button,
  Drawer,
  Box,
  Zoom,
  Fade,
  Paper,
} from '@mui/material';
import Grid from '@mui/material/Grid';
// Wimss context
import {
  useWimssController,
  setIsMobile,
  setCurrentPage,
  setCurrentTexts,
} from 'context';
import HoverImage from 'react-hover-image';

//import hero pictures
import BeachVB from 'assets/images/pictures/beach-beachvolleyball.png';
import BeachBackground from 'assets/images/pictures/beach01.png';
import Canoeing from 'assets/images/pictures/beach-canoeing.png';
import Pickleball from 'assets/images/pictures/beach-pickleball.png';
import Fishing from 'assets/images/pictures/beach-fishing.png';
import Frisbee from 'assets/images/pictures/beach-frisbee.png';
import Surfing from 'assets/images/pictures/beach-surfing.png';
import Hiking from 'assets/images/pictures/beach-hiking.png';
import Dogwalking from 'assets/images/pictures/beach-dogwalking.png';
import BeachChairs from 'assets/images/pictures/beach-chairs.png';
import BeachVBMobile from 'assets/images/pictures/beach-beachvolleyball-mobile.png';
import BeachBackgroundMobile from 'assets/images/pictures/beach01-mobile.png';
import CanoeingMobile from 'assets/images/pictures/beach-canoeing-mobile.png';
import PickleballMobile from 'assets/images/pictures/beach-pickleball-mobile.png';
import FishingMobile from 'assets/images/pictures/beach-fishing-mobile.png';
import FrisbeeMobile from 'assets/images/pictures/beach-frisbee-mobile.png';
import SurfingMobile from 'assets/images/pictures/beach-surfing-mobile.png';
import HikingMobile from 'assets/images/pictures/beach-hiking-mobile.png';
import DogwalkingMobile from 'assets/images/pictures/beach-dogwalking-mobile.png';
import BeachChairsMobile from 'assets/images/pictures/beach-chairs-mobile.png';
import WaveBanner from 'assets/images/pictures/wave-banner.png';
import MultipleSports from 'assets/images/pictures/multiple-sports.png';
import WaterDropBg from 'assets/images/pictures/water-drops-background-small.png';
import Schedules from 'assets/images/pictures/schedules.png';
import Joinus from 'assets/images/pictures/joinus.png';

import { initTexts, TimeOut } from 'utils/syncState';

const Home = () => {
  const [controller, dispatch] = useWimssController();
  const { currentLanguage, isMobile, currentPage, currentTexts } = controller;

  const Page = 'home';
  const { innerWidth: width } = window;

  const navigate = useNavigate();
  const [animateHero, setAnimateHero] = useState([]);

  const [animated, setAnimated] = useState(false);
  const [refreshActBtn, setRefreshActBtn] = useState(true);

  const staticHeros = [
    {
      id: 1,
      src: Canoeing,
      show: false,
      alt: 'Canoeing',
    },
    {
      id: 2,
      src: Surfing,
      show: false,
      alt: 'Surfing',
    },
    {
      id: 3,
      src: Pickleball,
      show: false,
      alt: 'Beach Pickleball',
    },
    {
      id: 4,
      src: Frisbee,
      show: false,
      alt: 'Frisbee',
    },
    {
      id: 5,
      src: Fishing,
      show: false,
      alt: 'Fishing',
    },
    {
      id: 6,
      src: Hiking,
      show: false,
      alt: 'Beach Hiking',
    },
    {
      id: 7,
      src: BeachVB,
      show: false,
      alt: 'Beach Volleyball',
    },
    {
      id: 8,
      src: BeachChairs,
      show: false,
      alt: 'Beach chairs',
    },
    {
      id: 9,
      src: Dogwalking,
      show: false,
      alt: 'Beach Dogwalking',
    },
  ];

  const staticHerosMobile = [
    {
      id: 1,
      src: CanoeingMobile,
      show: false,
      alt: 'Canoeing',
    },
    {
      id: 2,
      src: SurfingMobile,
      show: false,
      alt: 'Surfing',
    },
    {
      id: 3,
      src: PickleballMobile,
      show: false,
      alt: 'Beach Pickleball',
    },
    {
      id: 4,
      src: FrisbeeMobile,
      show: false,
      alt: 'Frisbee',
    },
    {
      id: 5,
      src: FishingMobile,
      show: false,
      alt: 'Fishing',
    },
    {
      id: 6,
      src: HikingMobile,
      show: false,
      alt: 'Beach Hiking',
    },
    {
      id: 7,
      src: BeachVBMobile,
      show: false,
      alt: 'Beach Volleyball',
    },
    {
      id: 8,
      src: BeachChairsMobile,
      show: false,
      alt: 'Beach chairs',
    },
    {
      id: 9,
      src: DogwalkingMobile,
      show: false,
      alt: 'Beach Dogwalking',
    },
  ];

  useEffect(() => {
    if (width <= 600) {
      setIsMobile(dispatch, true);
    } else setIsMobile(dispatch, false);
    setCurrentPage(dispatch, Page);
  }, []);

  useEffect(() => {
    initHero(isMobile);
  }, [isMobile]);

  useEffect(() => {
    if (animateHero.length > 0) {
      let flag = false;
      for (let i = 0; i < animateHero.length; i++) {
        if (animateHero[i].show) {
          flag = true;
          break;
        }
      }
      if (flag) setAnimated(true);
    }
  }, [animateHero]);

  useEffect(() => {
    if (currentLanguage !== '') {
      setRefreshActBtn(false);
    }

    //set currentTexts
    let pageTxts = initTexts(currentLanguage, currentPage);
    setCurrentTexts(dispatch, pageTxts);
  }, [currentLanguage, currentPage]);

  useEffect(() => {
    if (currentTexts !== null && !refreshActBtn) setRefreshActBtn(true);
  }, [currentTexts]);

  const onButtonClicked = (path) => {
    const pg = path.substring(1);
    setCurrentPage(dispatch, pg);
    navigate(path);
  };

  const initHero = (mobile = false) => {
    let animateArr = randomIntsFromInterval(1, 9, mobile ? 1 : 4);
    if (mobile) {
      staticHerosMobile.map((item) => {
        if (animateArr.includes(item.id)) item.show = true;
        else item.show = false;
        return item;
      });
      setAnimateHero(staticHerosMobile);
    } else {
      staticHeros.map((item) => {
        if (animateArr.includes(item.id)) item.show = true;
        else item.show = false;
        return item;
      });
      setAnimateHero(staticHeros);
    }
  };

  const randomIntsFromInterval = (min, max, numOfRnd) => {
    // min and max included, produce an array of ints, the size is numOfRnd
    const arrayInts = [];
    for (let i = 0; i < numOfRnd; i++) {
      arrayInts.push(Math.floor(Math.random() * (max - min + 1) + min));
    }
    return arrayInts;
  };

  const AnimateHero = () => {
    return (
      <Box sx={{ overflowY: 'hidden' }}>
        {animateHero.map((item) => {
          const rndDelay = randomIntsFromInterval(2, 5, 1)[0] * 500;

          return (
            <Fade
              in={item.show}
              key={item.id}
              style={{
                transitionDelay: rndDelay,
              }}>
              <img
                src={item.src}
                alt={item.alt}
                style={{
                  width: '100vw',
                  height: 'inherit',
                  position: 'absolute',
                  top: 0,
                  left: 0,
                }}
              />
            </Fade>
          );
        })}
      </Box>
    );
  };

  return (
    <Box sx={{ flexGrow: 1, mt: 0 }}>
      {currentTexts !== null &&
        currentTexts[0].paragraphs.length >= 3 &&
        refreshActBtn && (
          <Grid container direction='column' spacing={{ xs: 3, md: 4 }}>
            <Grid size={12}>
              <Box
                sx={{
                  backgroundImage: `url(${
                    isMobile ? BeachBackgroundMobile : BeachBackground
                  })`,
                  backgroundRepeat: 'no-repeat',
                  backgroundSize: '100% auto',
                  overflow: 'hidden',
                  overflowY: 'auto',
                  width: '100vw',
                  height: isMobile ? 628 : 600,
                  display: isMobile
                    ? { xs: 'block', sm: 'none' }
                    : { xs: 'none', sm: 'block' },
                  position: 'absolute',
                }}>
                {animated && <AnimateHero />}
              </Box>
            </Grid>
            <Grid size={12} sx={{ mt: isMobile ? 60 : 75 }}>
              {currentTexts !== null && refreshActBtn && (
                <Fade in={true} timeout={TimeOut}>
                  <Box
                    sx={{
                      backgroundImage: `url(${WaveBanner})`,
                      backgroundRepeat: 'repeat',
                      overflow: 'hidden',
                      overflowY: 'auto',
                      width: '100vw',
                      height: 207,
                      position: 'absolute',
                    }}>
                    <Stack
                      direction='column'
                      justifyContent='center'
                      alignItems='center'
                      spacing={2}
                      sx={{ mt: isMobile ? 8 : 5 }}>
                      <Typography
                        variant={isMobile ? 'h6' : 'h3'}
                        sx={{ fontFamily: 'Montserrat', fontWeight: 700 }}>
                        {currentTexts[0].paragraphs[0].title}
                      </Typography>
                      <Typography variant={isMobile ? 'h6' : 'h3'}>
                        {' '}
                      </Typography>
                      <Typography
                        variant={isMobile ? 'body' : 'h4'}
                        sx={{ fontFamily: 'Questrial', fontWeight: 600 }}>
                        {currentTexts[0].paragraphs[0].subtitle}
                      </Typography>
                    </Stack>
                  </Box>
                </Fade>
              )}
            </Grid>

            <Grid
              container
              size={{ xs: 12, sm: 6 }}
              sx={{ mt: isMobile ? 26 : 26 }}
              alignItems='center'
              justifyContent='center'
              flexDirection={{ xs: 'column', sm: 'row' }}>
              <Grid size={{ xs: 12, sm: 6 }}>
                {currentTexts !== null && refreshActBtn && (
                  <Fade in={true} timeout={TimeOut}>
                    <Box
                      sx={{
                        backgroundImage: `url(${WaterDropBg})`,
                        backgroundRepeat: 'repeat',
                        backgroundColor: 'rgba(255,255,255,0.5)',
                        backgroundBlendMode: 'lighten',
                        overflow: 'hidden',
                        width: '100%',
                        height: '100%',
                        position: 'inherit',
                        p: 3,
                      }}>
                      <Stack
                        justifyContent='center'
                        alignItems='center'
                        spacing={2}
                        sx={{ p: isMobile ? 0 : 3 }}>
                        <img
                          src={MultipleSports}
                          style={{ maxWidth: '90%', height: 'auto' }}
                          alt='Multiple Sports'
                        />
                      </Stack>
                    </Box>
                  </Fade>
                )}
              </Grid>
              <Grid size={{ xs: 12, sm: 6 }}>
                {currentTexts !== null && refreshActBtn && (
                  <Fade in={true} timeout={TimeOut}>
                    <Box
                      sx={{
                        backgroundImage: `url(${WaterDropBg})`,
                        backgroundRepeat: 'repeat',
                        backgroundColor: 'rgba(255,255,255,0.5)',
                        backgroundBlendMode: 'lighten',
                        overflow: 'hidden',
                        maxWidth: isMobile ? '100%' : 1200,
                        height: isMobile ? 540 : 480,
                        position: 'inherit',
                        p: 3,
                      }}>
                      <Stack
                        direction='column'
                        justifyContent='space-between'
                        alignItems={isMobile ? 'center' : 'flex-start'}
                        spacing={4}
                        sx={{ p: isMobile ? 2 : 3 }}>
                        <Typography
                          variant={isMobile ? 'body' : 'h5'}
                          sx={{
                            fontFamily: 'Montserrat',
                            textAlign: isMobile ? 'center' : 'left',
                            lineHeight: '150%',
                          }}>
                          {currentTexts[0].paragraphs[1].content}
                        </Typography>

                        {refreshActBtn && (
                          <HoverImage
                            src={currentTexts[0].paragraphs[1].button}
                            hoverSrc={currentTexts[0].paragraphs[1].btn_hover}
                            onClick={() =>
                              onButtonClicked(
                                currentTexts[0].paragraphs[1].action
                              )
                            }
                            style={{ width: '250px' }}
                          />
                        )}
                      </Stack>
                    </Box>
                  </Fade>
                )}
              </Grid>
            </Grid>
            <Grid size={12}>
              {currentTexts !== null && refreshActBtn && (
                <Fade in={true} timeout={TimeOut}>
                  <Box
                    sx={{
                      backgroundImage: `url(${WaveBanner})`,
                      backgroundRepeat: 'repeat',
                      overflow: 'hidden',
                      overflowY: 'auto',
                      width: '100vw',
                      height: 207,
                      position: 'absolute',
                    }}>
                    <Stack
                      direction='column'
                      justifyContent='center'
                      alignItems='center'
                      spacing={2}
                      sx={{ mt: isMobile ? 15 : 12 }}>
                      <Typography
                        variant={isMobile ? 'body' : 'h4'}
                        sx={{ fontFamily: 'Questrial', fontWeight: 600 }}>
                        {currentTexts[0].paragraphs[2].subtitle}
                      </Typography>
                    </Stack>
                  </Box>
                </Fade>
              )}
            </Grid>
            <Grid
              container
              size={{ xs: 12, sm: 6 }}
              sx={{ mt: isMobile ? 26 : 26 }}
              alignItems='center'
              justifyContent='center'
              flexDirection={{ xs: 'column', sm: 'row' }}>
              <Grid size={{ xs: 12, sm: 6 }}>
                {currentTexts !== null && refreshActBtn && (
                  <Fade in={true} timeout={TimeOut}>
                    <Box
                      sx={{
                        backgroundImage: `url(${WaterDropBg})`,
                        backgroundRepeat: 'repeat',
                        backgroundColor: 'rgba(255,255,255,0.5)',
                        backgroundBlendMode: 'lighten',
                        overflow: 'hidden',
                        width: '100%',
                        height: '100%',
                        position: 'inherit',
                        p: 3,
                      }}>
                      <Stack
                        justifyContent='center'
                        alignItems='center'
                        spacing={2}
                        sx={{ p: isMobile ? 2 : 3 }}>
                        <img
                          src={Schedules}
                          style={{ maxWidth: '90%', height: 'auto' }}
                          alt='Schedules'
                        />
                      </Stack>
                    </Box>
                  </Fade>
                )}
              </Grid>
              <Grid size={{ xs: 12, sm: 6 }}>
                {currentTexts !== null && refreshActBtn && (
                  <Fade in={true} timeout={TimeOut}>
                    <Box
                      sx={{
                        backgroundImage: `url(${WaterDropBg})`,
                        backgroundRepeat: 'repeat',
                        backgroundColor: 'rgba(255,255,255,0.5)',
                        backgroundBlendMode: 'lighten',
                        overflow: 'hidden',
                        maxWidth: isMobile ? '100%' : 1200,
                        height: '100%',
                        position: 'inherit',
                        p: 3,
                      }}>
                      <Stack
                        direction='column'
                        justifyContent='space-between'
                        alignItems={isMobile ? 'center' : 'flex-start'}
                        spacing={4}
                        sx={{ p: isMobile ? 2 : 3 }}>
                        {currentTexts[0].paragraphs[2].content
                          .split('\n')
                          .map((line, index) => (
                            <Typography
                              variant={isMobile ? 'body' : 'h5'}
                              sx={{
                                fontFamily: 'Montserrat',
                                textAlign: isMobile ? 'center' : 'left',
                                lineHeight: '150%',
                              }}>
                              {line}
                            </Typography>
                          ))}

                        {refreshActBtn && (
                          <HoverImage
                            src={currentTexts[0].paragraphs[2].button}
                            hoverSrc={currentTexts[0].paragraphs[2].btn_hover}
                            onClick={() =>
                              onButtonClicked(
                                currentTexts[0].paragraphs[2].action
                              )
                            }
                            style={{ width: '250px' }}
                          />
                        )}
                      </Stack>
                    </Box>
                  </Fade>
                )}
              </Grid>
            </Grid>
            <Grid size={12}>
              {currentTexts !== null && refreshActBtn && (
                <Fade in={true} timeout={TimeOut}>
                  <Box
                    sx={{
                      backgroundImage: `url(${WaveBanner})`,
                      backgroundRepeat: 'repeat',
                      overflow: 'hidden',
                      overflowY: 'auto',
                      width: '100vw',
                      height: 207,
                      position: 'absolute',
                    }}>
                    <Stack
                      direction='column'
                      justifyContent='center'
                      alignItems='center'
                      spacing={2}
                      sx={{ mt: isMobile ? 15 : 12 }}>
                      <Typography
                        variant={isMobile ? 'body' : 'h4'}
                        sx={{ fontFamily: 'Questrial', fontWeight: 600 }}>
                        {currentTexts[0].paragraphs[3].subtitle}
                      </Typography>
                    </Stack>
                  </Box>
                </Fade>
              )}
            </Grid>
            <Grid
              container
              size={{ xs: 12, sm: 6 }}
              sx={{ mt: isMobile ? 26 : 26 }}
              alignItems='center'
              justifyContent='center'
              flexDirection={{ xs: 'column', sm: 'row' }}>
              <Grid size={{ xs: 12, sm: 6 }}>
                {currentTexts !== null && refreshActBtn && (
                  <Fade in={true} timeout={TimeOut}>
                    <Box
                      sx={{
                        backgroundImage: `url(${WaterDropBg})`,
                        backgroundRepeat: 'repeat',
                        backgroundColor: 'rgba(255,255,255,0.5)',
                        backgroundBlendMode: 'lighten',
                        overflow: 'hidden',
                        width: '100%',
                        height: '100%',
                        position: 'inherit',
                        p: 3,
                      }}>
                      <Stack
                        justifyContent='center'
                        alignItems='center'
                        spacing={2}
                        sx={{ p: isMobile ? 2 : 3 }}>
                        <img
                          src={Joinus}
                          style={{ maxWidth: '90%', height: 'auto' }}
                          alt='Join Us'
                        />
                      </Stack>
                    </Box>
                  </Fade>
                )}
              </Grid>
              <Grid size={{ xs: 12, sm: 6 }}>
                {currentTexts !== null && refreshActBtn && (
                  <Fade in={true} timeout={TimeOut}>
                    <Box
                      sx={{
                        backgroundImage: `url(${WaterDropBg})`,
                        backgroundRepeat: 'repeat',
                        backgroundColor: 'rgba(255,255,255,0.5)',
                        backgroundBlendMode: 'lighten',
                        overflow: 'hidden',
                        maxWidth: isMobile ? '100%' : 1200,
                        height: 480,
                        position: 'inherit',
                        p: 3,
                      }}>
                      <Stack
                        direction='column'
                        justifyContent='space-between'
                        alignItems={isMobile ? 'center' : 'flex-start'}
                        spacing={4}
                        sx={{ p: isMobile ? 2 : 3 }}>
                        {currentTexts[0].paragraphs[3].content
                          .split('\n')
                          .map((line, index) => (
                            <Typography
                              variant={isMobile ? 'body' : 'h5'}
                              sx={{
                                fontFamily: 'Montserrat',
                                textAlign: isMobile ? 'center' : 'left',
                                lineHeight: '150%',
                              }}>
                              {line}
                            </Typography>
                          ))}

                        {refreshActBtn && (
                          <HoverImage
                            src={currentTexts[0].paragraphs[3].button}
                            hoverSrc={currentTexts[0].paragraphs[3].btn_hover}
                            onClick={() =>
                              onButtonClicked(
                                currentTexts[0].paragraphs[3].action
                              )
                            }
                            style={{ width: '250px' }}
                          />
                        )}
                      </Stack>
                    </Box>
                  </Fade>
                )}
              </Grid>
            </Grid>
          </Grid>
        )}
    </Box>
  );
};

export default Home;
